<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7.296 1.013a6.715 6.715 0 017.122 6.33c0 .113.041.393.101.71a18.01 18.01 0 00.1.49l.008.03.001.007v.002a.75.75 0 11-1.462.331l.731-.165-.732.165v-.004l-.002-.01-.008-.034a19.637 19.637 0 01-.11-.533c-.052-.279-.122-.683-.127-.962a5.215 5.215 0 00-8.164-3.949.75.75 0 11-.853-1.233 6.687 6.687 0 013.395-1.175zm-4.42 3.135a.75.75 0 01.287 1.02C2.697 6 2.45 7.128 2.515 8.185c.087 1.382.26 2.614.528 3.974a.75.75 0 11-1.472.29 30.747 30.747 0 01-.553-4.17c-.082-1.322.218-2.74.837-3.843a.75.75 0 011.02-.287zm4.688.046a3.794 3.794 0 014.023 3.55c.087 1.388.292 2.492.474 3.242a12.29 12.29 0 00.306 1.062l.018.048.003.01a.75.75 0 01-1.397.546l.699-.273-.699.273v-.001l-.001-.003-.003-.006-.007-.02a5.115 5.115 0 01-.112-.328 13.83 13.83 0 01-.266-.956 20.42 20.42 0 01-.512-3.5 2.294 2.294 0 10-4.579.286c.039.618.142 1.64.223 2.256a.75.75 0 11-1.487.195 42.01 42.01 0 01-.233-2.358 3.794 3.794 0 013.55-4.023zm-2.292 7.944a.75.75 0 01.897.567c.099.441.257.979.359 1.296a.75.75 0 11-1.428.459c-.11-.342-.282-.925-.395-1.426a.75.75 0 01.567-.896zm3.23-3.874a.75.75 0 00-1.497.094c.126 2.002.434 3.366.98 5.24a.75.75 0 101.44-.418c-.527-1.81-.807-3.06-.923-4.916z"
    fill="currentColor"
  />
</svg>
